import React from "react";
import { useSelector } from "react-redux";

import { PiWarningOctagon } from "react-icons/pi";

import "./styles.scss"
import uris from "../../../../config/uris"
import { useLocation } from "react-router-dom";

const UserLimitExceedModal = () => {
    const location = useLocation()
    const { data: userLimit } = useSelector(state => state.maxUserLimit)

    const applicableRoutes = [uris?.companyResearch, uris?.customResearch, uris?.investorResearch, uris?.realEstateResearch]

    return (
        <>
            {(userLimit?.isUserLimitExceeded?.modal && applicableRoutes?.includes(location?.pathname)) && (
                <div className="limit-exceed-modal">
                    <div className="limit-exceed-modal-contents">
                        <div className="modal-icon">
                            <PiWarningOctagon />
                        </div>
                        <div className="modal-title">Trial Limit Exceeded</div>
                        <div className="modal-description">Usage limit exceeded for trial. Please contact your Account Manager</div>
                        <div className="modal-buttons-section">
                            <div className="modal-button">Ok</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default UserLimitExceedModal